import ContentProvider from './ContentProvider';

export default ContentProvider;